import React from "react";
import _ from "lodash";
import { useFormState } from "react-final-form";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";

const PlayerStatsCounter = ({ sportCode, side }) => {
  const { values } = useFormState();
  const theme = useTheme();
  const borderColor = _.get(theme, "palette.grey[400]");
  const classes = makeStyles({
    container: {
      marginBottom: theme.spacing(3),
      paddingBottom: theme.spacing(1),
      borderBottom: `1px solid ${borderColor}`
    },
    points: {
      fontWeight: "bold"
    }
  })();

  if (sportCode !== "girls-basketball" && sportCode !== "boys-basketball")
    return null;

  const players = _.get(values, [side, "formPlayers"], []);
  const totalPointsValue = players
    .map((player) => _.get(player, "totalPoints", 0))
    .reduce((previousValue, currentValue) => {
      return previousValue + currentValue;
    }, 0);

  return (
    <div className={classes.container}>
      <span>Total Player Points: </span>
      <span className={classes.points}>{totalPointsValue}</span>
    </div>
  );
};

export default PlayerStatsCounter;
